module.exports = __webpack_public_path__ + "img/97.67d4f5fe.jpg";